import React from 'react';

import { useIntlDictionary } from 'hooks/useIntlDictionary';
import { TableTr, TableTd } from 'design/table';
import { PartnerClientsTableItem } from 'types/partnerClientsTable';
import { TextComponent } from 'design/text/textComponents';
import { HoverableTooltipComponent } from 'design/hoverableTooltip/hoverableTooltipComponents';
import { UnderlinedTextComponent } from 'design/underlinedText/underlinedTextComponents';

type Props = {
  item: PartnerClientsTableItem;
  active: boolean;
  onClick(item: PartnerClientsTableItem): void;
};

export const PartnerTrialClientsTableRow = (props: Props) => {
  const { item, active, onClick } = props;

  const { partnerClientsTable: ownDictionary } = useIntlDictionary();

  const onRowClick = React.useCallback(() => {
    onClick(item);
  }, [onClick, item]);

  return (
    <TableTr active={active} onClick={onRowClick}>
      <TableTd text={item.organization} />
      <TableTd text={ownDictionary.contactFullNameText(item)} />
      <TableTd text={item.position} />
      <TableTd text={item.phone} />
      <TableTd
        text={item.orgSize ? ownDictionary.orgSizeValue(item.orgSize) : '-'}
      />
      <TableTd text={`${item.licensesCount}`} />
      <TableTd
        disableNoBreakHack
        text={
          <HoverableTooltipComponent
            text={ownDictionary.expectedIncomeTooltipText}
          >
            <TextComponent color="primary" size="s">
              <UnderlinedTextComponent>
                {ownDictionary.incomeValue(item.income?.amount || 0)}
              </UnderlinedTextComponent>
            </TextComponent>
          </HoverableTooltipComponent>
        }
      />
      <TableTd
        text={
          <TextComponent color="successful" size="s">
            {ownDictionary.subscribtionStatusValue(item)}
          </TextComponent>
        }
      />
    </TableTr>
  );
};
